import { MerchantRestrictionsResponseUI } from 'src/types/OrderRestrictions';

export function transformCorpMerchantRestrictionsToMeta(
  merchantRestrictions: Partial<MerchantRestrictionsResponseUI>[]
): MerchantRestrictionsResponseUI[] {
  return merchantRestrictions.map((restriction) => ({
    type: restriction.type,
    displayName: restriction.type,
    description: '',
  }));
}
